import { render, staticRenderFns } from "./ProfileWidget.vue?vue&type=template&id=145696ff&"
import script from "./ProfileWidget.vue?vue&type=script&lang=ts&"
export * from "./ProfileWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports